// extracted by mini-css-extract-plugin
export default {"divisor-secao":"DivisorSecao_divisor-secao__lQZJ+","bolinhas-divisor":"DivisorSecao_bolinhas-divisor__Nix8p","moverBolinhas":"DivisorSecao_moverBolinhas__BmOXL"};